import React from 'react';
import { Wizard } from 'react-use-wizard';
import StartTrialStep from './StartTrialStep';
import StartTrialStatusStep from './StartTrialStatusStep';
import T from 'prop-types';
import { noop } from 'lodash';

const StartTrialWizard = ({
  onCancel,
  onStartTrial,
  callback = noop,
}) => {
  return (
    <Wizard>
      <StartTrialStep onCancel={onCancel} />
      <StartTrialStatusStep
        onNext={onStartTrial ?? onCancel}
        callback={callback}
      />
    </Wizard>
  );
};

StartTrialWizard.propTypes = {
  onCancel: T.func,
  onStartTrial: T.func,
  isHighResClicked: T.bool,
  callback: T.func,
};

export default StartTrialWizard;
